import type { StudioProject } from "./types";

// Proyecto en blanco para cuentas nuevas. Antes de este archivo, toda cuenta nueva arrancaba
// mostrando (y, por el efecto de autoguardado de studioStore.tsx, terminaba persistiendo)
// sampleProject — la plantilla completa de demostración "BlackRed Commerce" con navbar, hero,
// tablas y workflows ya construidos. Eso hacía que un cliente que entraba por primera vez
// encontrara la app "ya hecha" en vez de un lienzo vacío que el asistente (blacked) lo guíe a
// construir. sampleProject se sigue usando para la acción explícita "Restaurar demo", nunca
// como estado inicial automático de una cuenta real.
export function createEmptyProject(): StudioProject {
  const now = new Date().toISOString();
  return {
    id: crypto.randomUUID(),
    name: "Mi proyecto",
    slug: "mi-proyecto",
    description: "",
    version: "0.1.0",
    createdAt: now,
    updatedAt: now,
    theme: {
      primary: "#ff3d56",
      secondary: "#7c3aed",
      background: "#08080a",
      surface: "#141418",
      text: "#f7f7f8",
      muted: "#a1a1aa",
      radius: 18,
      font: "Manrope",
    },
    components: [],
    tables: [],
    workflows: [],
    customCode: {
      html: "",
      css: "",
      javascript: "",
      detached: false,
    },
    activity: [],
  };
}
